// Create a new store instance.
import {createStore} from "vuex";
import {selector} from "@/store/modules/selector";

export const store = createStore({
    modules: {
        selector: selector
    },
    state: () => ({
        loading: false,
        cabData:{
            cabinetId: 26,
            officeId: 26
        },
        vModeWeek: 0, // режим отображения
        xWeek: 2, // масштаб
        data: {
            'dates':{},
            'prices': {},
            'cabinet': {},
            'bookings': {},
            'user': {},
        },
        commission: 0
    }),
    mutations: {
        setX(state, val){
            state.xWeek = val;
        },
        setVMode(state, val){
            state.vModeWeek = val;
        },
        setLoading(state, val) {
            state.loading = val;
        },
        // resetData(state){
        //     var size = Object.keys(state.data).length;
        //     if(size){
        //         for (var keyM in state.data){
        //             delete state.data[keyM]
        //         }
        //     }
        //     state.data = {
        //         'dates':{},
        //         'prices': {},
        //         'cabinet': {},
        //         'bookings': {},
        //         'user': {},
        //     }
        // },
        setData(state, val){

            state.data.dates = val.dates
            state.data.cabinet = val.cabinet
            state.data.bookings = val.bookings
            state.data.user = val.user

            for (var key in val.prices){
                let d = val.prices[key]
                let nData = [];
                for (var k in d){
                    let m = Object.assign({},d[k]);
                    let s = Object.assign({},d[k]);
                    m['minute'] = '1/2'
                    nData.push(m)
                    s['minute'] = '2/2'
                    nData.push(s)
                }
                state.data.prices[key] = nData
            }

            // console.log(state.data.prices)
            // state.data.prices = val.nData

        },
        setCabData(state, data){
            state.cabData = data
        },
        updateUserBalance(state, balance) {
            state.data.user.userBalance = balance;
        },
        setCommission(state,data){
            state.commission  = data.commission
        }
    },
    actions: {
        setX({commit}, val){
            commit('setX',val);
        },
        setVMode({commit}, val){
            commit('setVMode',val);
        },
        setData({commit}, data) {
            // commit('resetData')
            let saveData = {
                'prices': data.prices,
                'cabinet': data.cabinet,
                'bookings': data.bookings,
                'user': data.user,
                'dates': data.dates,
            }
            commit('setData', saveData);
            commit('setCommission',data);
        },
        updateUserBalance({commit}, balance) {
            commit('updateUserBalance', balance);
        },

    }
})
